import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "min-h-screen bg-primary-50" }
const _hoisted_2 = { class: "container mx-auto px-4 py-8 max-w-4xl" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "text-display-sm font-heading font-bold text-primary-800 mb-6" }, " Active Votes ", -1)
const _hoisted_4 = {
  key: 0,
  class: "bg-white rounded-xl border border-primary-200 shadow-soft p-12 text-center"
}
const _hoisted_5 = /*#__PURE__*/_createStaticVNode("<div class=\"w-16 h-16 bg-primary-100 rounded-full flex items-center justify-center mx-auto mb-4\"><svg class=\"w-8 h-8 text-primary-400\" fill=\"none\" stroke=\"currentColor\" viewBox=\"0 0 24 24\"><path stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"2\" d=\"M9 5H7a2 2 0 00-2 2v12a2 2 0 002 2h10a2 2 0 002-2V7a2 2 0 00-2-2h-2M9 5a2 2 0 002 2h2a2 2 0 002-2M9 5a2 2 0 012-2h2a2 2 0 012 2m-6 9l2 2 4-4\"></path></svg></div><h2 class=\"text-xl font-heading font-semibold text-primary-800 mb-2\"> No Active Votes </h2><p class=\"text-primary-500\"> There are no votes open at this time. Check back later! </p>", 3)
const _hoisted_8 = [
  _hoisted_5
]
const _hoisted_9 = {
  key: 1,
  class: "space-y-4"
}

import BallotComponent from "@/components/ballot/BallotComponent.vue";
import { useVoteStore } from "@/stores/votes";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const votes = useVoteStore();
votes.get_votes();

const activeVotes = computed(() => votes.active_votes);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_unref(activeVotes).length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_8))
        : (_openBlock(), _createElementBlock("div", _hoisted_9, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(activeVotes), (vote) => {
              return (_openBlock(), _createElementBlock("div", {
                key: vote.id
              }, [
                _createVNode(BallotComponent, { vote: vote }, null, 8, ["vote"])
              ]))
            }), 128))
          ]))
    ])
  ]))
}
}

})